import { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import { authenticationState, customerState } from '@repo/unicity'
import { useCurrentLanguage } from '@/core/utils'

export interface CustomerDisplay {
    customerName: string
    profilePicUrl: string
    baId: string
    isLoading: boolean
}

const resolveCustomerName = (humanName: Record<string, string | undefined> | undefined, language: string): string => {
    if (!humanName) return ''

    if (language !== 'EN') {
        const nativeKey = Object.keys(humanName).find(k => k.startsWith('fullName@'))
        const nativeName = nativeKey ? humanName[nativeKey] : ''
        if (nativeName) return nativeName
    }

    if (humanName.fullName) return humanName.fullName
    return [humanName.firstName, humanName.lastName].filter(Boolean).join(' ')
}

export const useCustomerDisplay = (): CustomerDisplay => {
    const authentication = useAtomValue(authenticationState)
    const customer = useAtomValue(customerState)
    const language = useCurrentLanguage()

    const customerName = useMemo(
        () => resolveCustomerName(customer.humanName as Record<string, string | undefined> | undefined, language),
        [customer.humanName, language]
    )

    const profilePicUrl = customer.profilePicture?.sizes?.[0]?.media || customer.profilePicture?.href || ''

    return {
        customerName,
        profilePicUrl,
        baId: authentication.baId || '',
        isLoading: Boolean(authentication.baId && !customerName)
    }
}
